__turbopack_context__.v({
  "figHost": "ITpy2a_figHost",
});
